import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import {
  AccordionIcon,
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Icon,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { Box, Button } from "@chakra-ui/react";
import { HStack } from "@chakra-ui/react";

const NavigationAccordion = ({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) => {
  return (
    <Accordion allowToggle textAlign={"left"}>
      <AccordionItem>
        {({ isExpanded }) => (
          <>
            <AccordionButton textAlign={"left"} background="gray.100">
              <HStack w="full" gap={2}>
                <AccordionIcon as={FaChevronDown} fontSize={"xs"} />
                <Text w="full" fontWeight={"medium"}>
                  {label} {isExpanded ? "(Hide steps)" : "(Show all steps)"}
                </Text>
              </HStack>
            </AccordionButton>
            <AccordionPanel w="full">{children}</AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

const DesktopNavigation = ({
  children,
}: {
  children: React.ReactNode;
  label: string;
}) => {
  return (
    <HStack
      borderWidth={1}
      borderColor={"gray.200"}
      rounded={"xl"}
      p={1}
      px={4}
    >
      {children}
    </HStack>
  );
};

const EditScheduledModalNavigation = ({
  steps,
  currentStep,
  setCurrentStep,
  isStepUpdated,
}: {
  steps: { label: string; component: React.ComponentType<any> }[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
  isStepUpdated: (step: {
    label: string;
    component: React.ComponentType<any>;
  }) => boolean;
}) => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  const WrapperComponent = isMobile ? NavigationAccordion : DesktopNavigation;

  return (
    <WrapperComponent label={steps[currentStep]?.label}>
      {steps.map((step, index) => (
        <Box key={index} position="relative" display="flex" alignItems="center">
          <Button
            variant={"ghost"}
            fontWeight={currentStep === index ? "bold" : "normal"}
            onClick={() => setCurrentStep(index)}
          >
            <Box position="relative" display="inline-block">
              {step.label}
              {isStepUpdated(step) && (
                <Box
                  as="span"
                  position="absolute"
                  top={-1}
                  right={-3}
                  width="12px"
                  height="12px"
                  bg="blue.400"
                  borderRadius="full"
                  border="2px solid white"
                  zIndex={1}
                />
              )}
            </Box>
          </Button>
          {index < steps.length - 1 && (
            <Icon as={FaChevronRight} color="gray.400" boxSize={4} />
          )}
        </Box>
      ))}
    </WrapperComponent>
  );
};

export default EditScheduledModalNavigation;
